import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { AllEnterpriseModule, LicenseManager,ModuleRegistry } from "ag-grid-enterprise";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { LOGIN_URL, setTokenFromURL, apiFetch } from './utils/auth.js'
import { AuthProvider } from './utils/AuthProvider.jsx'
import PersistLogin from './components/common/PersistLogin.jsx'
import Unauthorized from './components/common/Unauthorized.jsx'
import ProtectedRoute from './components/common/ProtectedRoute.jsx'
import { CustomThemeProvider } from './components/common/ThemeContext.jsx';
import LoadingOverlay from "./components/common/LoadingOverlay.jsx";
import VersionBanner from "./components/common/VersionBanner";
import BalDay from './BalDay.jsx';
import './ag_grid.css'


LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-079074}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Altop_Energy_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Galaxy}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Galaxy}_need_to_be_licensed___{Galaxy}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_March_2026}____[v3]_[01]_MTc3MzE4NzIwMDAwMA==2dffc0c72de44d5837765b8aa995bc3f"
);
ModuleRegistry.registerModules([AllEnterpriseModule]);


function App() {
  const [iso, setIso] = useState("");
  const [mode, setMode] = useState("light");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { iso } = setTokenFromURL();
    if (iso) {
      setIso(iso);
    }
  }, []);
  useEffect(() => {
    const {mode: urlMode } = setTokenFromURL();

    // Apply the theme IMMEDIATELY from the launch URL (?mode=, set by the dashboard) or the last-known
    // cached theme, so the app paints in the correct theme with no network wait and no flash. Then stop
    // blocking first paint — login/apps/ (drawer app-list + theme reconcile) loads in the BACKGROUND
    // since on a secondary app that data feeds the nav drawer, which the user rarely touches on load.
    const cachedTheme = localStorage.getItem('altop_theme');
    if (urlMode) {
      setMode(urlMode);
    } else if (cachedTheme) {
      setMode(cachedTheme);
    }
    setLoading(false);

    // Background: refresh preferences without blocking render.
    (async () => {
      try {
        const response = await apiFetch('login/apps/');
        if (response) {
          const data = await response.json();
          if (data.defaultTheme) {
            setMode(data.defaultTheme);
            try { localStorage.setItem('altop_theme', data.defaultTheme); } catch (e) { /* ignore */ }
          }
        }
      } catch (error) {
        console.error('Failed to fetch user preferences:', error);
      }
    })();
  }, []);

  if (loading) {
    return <LoadingOverlay loading={loading} setLoading={setLoading} />;
  }
  return (
    <AuthProvider>
      <CustomThemeProvider mode={mode} setMode={setMode}>
        <Router>
          <Box>
            <VersionBanner appName="BalDayDashboard" />
            <Routes>
              <Route element={<PersistLogin />}>
                <Route path={LOGIN_URL} />
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<BalDay iso={iso} />} />
                  <Route path="*" element={<BalDay iso={iso} />} />
                </Route>
                <Route path='/unauthorized' element={<Unauthorized />} />
              </Route>
            </Routes>
          </Box>
        </Router>
      </CustomThemeProvider>
    </AuthProvider>
  );
}

export default App;